module.exports = __webpack_public_path__ + "static/samsung-defb806f9510e4e8993eb3626fd28b2a.png";